import { useStore } from 'effector-react'
import * as React from 'react'
import { Params } from './types'
import {
  $comments,
  commentListBackendUpdated,
  commentListMounted,
  getComments,
} from './model'

export const useCommentsList = (p: Params, skip = false) => {
  React.useEffect(() => {
    if (!skip) {
      commentListMounted(p)
      return commentListBackendUpdated.watch((params) => {
        if (
          params.entityType === p.entityType &&
          params.entityId === p.entityId
        ) {
          commentListMounted(params)
        }
      })
    }
  }, [p.entityType, p.entityId])

  const loading = useStore(getComments.pending)

  const comments = useStore($comments)
  return { comments, loading }
}
